export default {
  common: {
    currentLanguage: 'The current language is "{{lng}}"',
    no_internet_connection: "Internet connection is not available",
    loading: "Loading...",
    database_not_loaded: "Database is not loaded",
    developed_by: "Developed by",
    in_cooperation_with: "in cooperation with:"
  },

  regions: {
    push_tips_infos: "Receive wax tips and product infos",
    push_history_link: "Push notifications"
  },

  sportTypes: {
    screen_title: "Sport Type"
  },

  sportVariants: {
    screen_title: "Sport Variant"
  },

  parameters: {
    screen_title: "Parameters",
    temperature: "Temperature",
    air_humidity: "Air humidity",
    snow_type: "Snow type",
    snow_types: {
      1: "New snow < 24h",
      2: "Transformed snow > 24h",
      3: "Spring and old snow",
      4: "Artificial snow"
    },
    show_results: "Show results"
  },

  results: {
    screen_title: "Results",
    no_results: "No results for selected parameters",
    layers: {
      layer_1: "1st layer",
      layer_2: "2nd layer",
      layer_3: "3rd layer"
    },
    protip: "Pro-Tip"
  },

  products: {
    button_wishlist: "Wishlist",
    button_remove_from_wishlist: "Remove from Wishlist",
    button_video: "Video",
    button_buynow: "Buy now"
  },

  weather: {
    screen_title: "Weather",
    select_country: "Select Country",
    cancel: "Cancel",
    no_providers: "No Weather Providers"
  },

  wishlist: {
    screen_title: "Wishlist",
    no_products: "There is no products in your wishlist",
    send_to_email: "Send wishlist to your email address",
    email_placeholder: "Your email address",
    button_send: "Send",
    button_cancel: "Cancel",
    send_to_email_success:
      "Your wishlist is succesfully sent to selected email address"
  },

  settings: {
    screen_title: "Settings",
    app_name: "HWK Ski Waxing Advisor",
    app_version: "App version",
    db_version: "Last database update",
    refresh_database: "Refresh database",
    button_impressum: "Impressum",
    button_privacy: "Privacy",
    button_website: "Website",
    button_reset_settings: "Reset all settings",
    action_reset_all: "Reset all settings",
    action_reset_cancel: "Cancel",
    action_are_you_sure: "Are you sure?",
    new_update_available:
      "New App update available. It will be downloaded and installed shortly.",
    already_updated: "You already have latest App version."
  },

  notifications: {
    screen_title: "Notifications",
    delete: "Delete",
    no_notifications: "There are no new Notifications"
  }
};
